import { Meet } from "types";
import { ATTACHMENT_DOC_PREFIX, generateId } from "./docHelper";
import { COUCH_DB_SERVER } from "./api";

export const uploadAttachment = async ({
  meet,
  file,
  name,
}: {
  meet: Meet;
  file: File;
  name: string;
}) => {
  const attachmentId = generateId(ATTACHMENT_DOC_PREFIX);
  const encodedName = encodeURIComponent(name);

  const docResponse = await fetch(
    `${COUCH_DB_SERVER}/${meet._id}/${attachmentId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ _id: attachmentId, name }),
      credentials: "include",
    },
  );

  if (!docResponse.ok) {
    const errorData = await docResponse.json();
    throw new Error(errorData.reason || "Document creation failed");
  }

  const docResult = await docResponse.json();

  const response = await fetch(
    `${COUCH_DB_SERVER}/${meet._id}/${attachmentId}/${encodedName}?rev=${docResult.rev}`,
    {
      method: "PUT",
      headers: { "Content-Type": file.type },
      body: file,
      credentials: "include",
    },
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.reason || "Upload failed");
  }

  return response.json();
};
